/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/commissioners_findings/files/r23_6319_c.pdf'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/524797/%E6%98%8E%E6%84%9B%E5%90%91%E6%99%B4%E8%BB%92%E9%81%BA%E5%A4%B1%E7%90%86%E5%A4%A7%E6%B1%82%E5%8A%A9%E8%80%85%E8%B3%87%E6%96%99-%E6%A0%A1%E6%96%B9-usb%E5%85%A7%E6%9C%89%E6%9C%AA%E5%8A%A0%E5%AF%86%E5%90%8C%E5%AD%B8%E8%B3%87%E6%96%99'
          );
        }}
        className="source2"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/commissioners_findings/files/r23_6319_c.pdf'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/524797/%E6%98%8E%E6%84%9B%E5%90%91%E6%99%B4%E8%BB%92%E9%81%BA%E5%A4%B1%E7%90%86%E5%A4%A7%E6%B1%82%E5%8A%A9%E8%80%85%E8%B3%87%E6%96%99-%E6%A0%A1%E6%96%B9-usb%E5%85%A7%E6%9C%89%E6%9C%AA%E5%8A%A0%E5%AF%86%E5%90%8C%E5%AD%B8%E8%B3%87%E6%96%99'
          );
        }}
        className="source2"
      />
    </div>
  </>
);

export default Components004;
